import { render, staticRenderFns } from "./ContattiComponent.vue?vue&type=template&id=56a987c4&scoped=true&"
import script from "./ContattiComponent.vue?vue&type=script&lang=js&"
export * from "./ContattiComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContattiComponent.vue?vue&type=style&index=0&id=56a987c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a987c4",
  null
  
)

export default component.exports